/**
 * @generated SignedSource<<e75601c34add9f6ad46425079cee287d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type KPICreateSubTeamSelectTeamQuery$variables = Record<PropertyKey, never>;
export type KPICreateSubTeamSelectTeamQuery$data = {
  readonly currentStore: {
    readonly publicTeams: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"ListItemTeamIndicator_team">;
    }>;
  };
};
export type KPICreateSubTeamSelectTeamQuery = {
  response: KPICreateSubTeamSelectTeamQuery$data;
  variables: KPICreateSubTeamSelectTeamQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "KPICreateSubTeamSelectTeamQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "currentStore",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "publicTeams",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ListItemTeamIndicator_team"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "KPICreateSubTeamSelectTeamQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a755e3be4732d51e46bb1fe4af8f9023",
    "id": null,
    "metadata": {},
    "name": "KPICreateSubTeamSelectTeamQuery",
    "operationKind": "query",
    "text": "query KPICreateSubTeamSelectTeamQuery {\n  currentStore {\n    publicTeams {\n      id\n      name\n      ...ListItemTeamIndicator_team\n    }\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment ListItemTeamIndicator_team on Team {\n  ...AHTeamIconCircle\n}\n"
  }
};
})();

(node as any).hash = "9a2b355463857f24d67c281eab5499fe";

export default node;
